import apiClient from './client';

export const submitLandingLead = (payload) => {
  return apiClient.post('public/landing-leads', payload);
};

export const mapDemoFormToPayload = (values) => ({
  name: values.name.trim(),
  work_email: values.workEmail.trim(),
  phone_number: values.phone.trim(),
  job_title: values.jobTitle.trim(),
  company_name: values.companyName.trim(),
  country: values.country,
  monthly_active_users: values.monthlyUsers,
  heard_about_us: values.hearAboutUs.trim(),
  comments: values.comments.trim(),
});
